import { updateMiniCartItemCount } from "../sections/header";
import { setPreorderOnCartLevel, getCart } from "../helpers"

/** @param {HTMLElement} baseElement */
export function init(baseElement) {
  // Initialize buttons
  const buttonsPlus = Array.from(
    baseElement.querySelectorAll(".main-cart__button--plus")
  );
  const buttonsMinus = Array.from(
    baseElement.querySelectorAll(".main-cart__button--minus")
  );

  for (let button of buttonsPlus) {
    button.addEventListener("click", addItem);
  }
  for (let button of buttonsMinus) {
    button.addEventListener("click", removeItem);
  }
}

async function addItem(e) {
  e.preventDefault();
  let lineItemKey = e.target.dataset.lineItemKey;
  if (!lineItemKey) {
    return;
  }
  let currentQuantity = e.target.dataset.quantity;
  let newQuantity = Number(currentQuantity) + 1;
  // Can't check if the quantity is possible to buy
  // See here: https://community.shopify.com/c/technical-q-a/product-get-not-showing-inventory-quantity/m-p/1336851/highlight/true#M67516
  e.target.previousElementSibling.innerHTML = "...";
  updateQuantity(lineItemKey, newQuantity);
}

async function removeItem(e) {
  e.preventDefault();
  let lineItemKey = e.target.dataset.lineItemKey;
  if (!lineItemKey) {
    //console.log("Line item's key is missing");
    return;
  }
  let currentQuantity = e.target.dataset.quantity;
  let newQuantity = Number(currentQuantity) - 1;
  if (newQuantity == 0) {
    //console.log("Do you want to remove the item?");
    return;
  }

  e.target.nextElementSibling.innerHTML = "...";
  updateQuantity(lineItemKey, newQuantity);
}

// https://shopify.dev/api/ajax/reference/cart#update-line-item-quantities
async function updateQuantity(lineItemKey, quantity) {
  let data;
  try {
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: {
            [`${lineItemKey}`]: `${quantity}`,
          },
          // https://shopify.dev/api/ajax/reference/cart#bundled-section-rendering
          sections: "main-cart",
        }),
      }
    );
    data = await response.json();

    const newCart = await getCart();
    const isPreorder = newCart.items.find(item => item.properties && item.properties._is_preorder)
    const preorderAlreadySet = data.attributes && !!data.attributes['_is_preorder'];

    if (isPreorder && !preorderAlreadySet) {
      await setPreorderOnCartLevel(true);
    } else if(!isPreorder) {
      await setPreorderOnCartLevel(false);
    }

  } catch (e) {
    console.log("Error", e.message);
  }
  // TODO:
  /**
   * https://dmitripavlutin.com/javascript-fetch-async-await/
   * response.ok property lets you separate good from bad HTTP response statuses.
   * if the response has status 200-299 response.ok returns 'true'
   * if there's a bad HTTP status (outside of the range 200-299) response.ok returns 'false'
   * so you can throw an error manually
   *
   * Then: fetch() rejects only if a request cannot be made or a response cannot be retrieved
   * fetch() will not return error for 404
   * */
  if (typeof data !== "object") return;

  if ("items" in data) {
    // Success!
    updateLineItem(data.sections["main-cart"], lineItemKey);
  } else if ("description" in data) {
    // Error!
    window.alert(
      typeof data.description === "string"
        ? data.description
        : "Something went wrong"
    );
  }
}

function updateLineItem(sectionHTML, lineItemKey) {
  const updatedSection = new DOMParser().parseFromString(
    sectionHTML,
    "text/html"
  );

  const updatedItem = updatedSection.querySelector(
    `[data-key='${lineItemKey}']`
  ).innerHTML;
  const currentItem = document.querySelector(`[data-key='${lineItemKey}']`);
  currentItem.innerHTML = updatedItem;

  const updatedSummary = updatedSection.querySelector(
    ".main-cart__order-summary"
  ).innerHTML;
  const currentSummary = document.querySelector(".main-cart__order-summary");
  currentSummary.innerHTML = updatedSummary;

  // Re-initialize newly rendered buttons
  const buttonPlus = currentItem.querySelector(".main-cart__button--plus");
  const buttonMinus = currentItem.querySelector(".main-cart__button--minus");

  buttonPlus.addEventListener("click", addItem);
  buttonMinus.addEventListener("click", removeItem);

  updateMiniCartItemCount();
}
